var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row py-3" }, [
        _c(
          "div",
          { staticClass: "col-sm-12 col-lg-6 d-flex align-items-center" },
          [
            _c("h2", [_vm._v("\n        Interacciones RRSS\n      ")]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ml-2 btn btn-success btn-xs ",
                attrs: { type: "button", disabled: _vm.disabled },
                on: { click: _vm.downloadExcel },
              },
              [
                _c("i", { staticClass: "fa fa-download" }),
                _vm._v("\n\n         \n\n        "),
                _c("span", { staticClass: "bold" }, [
                  _vm._v("\n          Exportar\n        "),
                ]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-sm-12 col-lg-6 d-flex align-items-center justify-content-start justify-content-md-end",
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-0" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rangeInit,
                    expression: "rangeInit",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "date",
                  max: _vm.today,
                  disabled: _vm.disabledRange,
                },
                domProps: { value: _vm.rangeInit },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.rangeInit = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-0" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rangeEnd,
                    expression: "rangeEnd",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "date",
                  max: _vm.today,
                  disabled: _vm.disabledRange,
                },
                domProps: { value: _vm.rangeEnd },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.rangeEnd = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ml-2 btn btn-success btn-xs ",
                attrs: { type: "button", disabled: _vm.disabled },
                on: {
                  click: function ($event) {
                    return _vm.ChangeRange()
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v("\n\n             \n\n            "),
                _c("span", { staticClass: "bold" }, [
                  _vm._v("\n          Buscar\n        "),
                ]),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      !_vm.loading
        ? [
            _vm.cards.length > 0
              ? _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(_vm.cards, function (card, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-lg-6 col-md-6" },
                      [_c("Card", { attrs: { declaration: card } })],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-12" }, [
                _c("div", { staticClass: "ibox" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "ibox-content" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-lg-6" },
                        [
                          _c("Bar", {
                            attrs: {
                              height: 150,
                              title: "Flujo de interacciones por horario",
                              declaration: _vm.ISchedule,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-lg-6 pt-3" },
                        [
                          _c("ListPercent", {
                            attrs: { declaration: _vm.percent },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-6" }, [
                _c("div", { staticClass: "ibox " }, [
                  _c("div", { staticClass: "ibox-title" }, [
                    _c("h5", [
                      _vm._v(
                        "\n              Gráficos Específicos de Chatbot Salud Total\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ibox-tools" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass:
                            "dropdown-menu\n                dropdown-user",
                          staticStyle: {
                            position: "absolute",
                            top: "-80px",
                            left: "26px",
                            "will-change": "top, left",
                          },
                          attrs: { "x-placement": "top-start" },
                        },
                        [
                          _vm._l(_vm.tagsGraphics, function (item, i) {
                            return [
                              item.tag == "chat"
                                ? _c("li", { key: i }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeChart(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\n                      " +
                                            _vm._s(item.value) +
                                            "\n\n                    "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._m(4),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ibox-content" }, [
                    _vm.showChat == "usuarios_tipo_documento"
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-lg-12" },
                            [
                              _c("Bar", {
                                attrs: {
                                  height: 250,
                                  declaration: _vm.tipoDocumento,
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showChat == "opciones_menu_principal"
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-lg-12",
                              attrs: { id: "opciones_menu_principal" },
                            },
                            [
                              _c("Bar", {
                                attrs: {
                                  height: 250,
                                  declaration: _vm.opcionesMenu,
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6" }, [
                _c("div", { staticClass: "ibox" }, [
                  _c("div", { staticClass: "ibox-title" }, [
                    _c("h5", [
                      _vm._v(
                        "\n              % Opciones cada Submenús de cada Menú\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ibox-tools" }, [
                      _vm._m(5),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "dropdown-menu dropdown-user",
                          staticStyle: {
                            position: "absolute",
                            top: "-80px",
                            left: "26px",
                            "will-change": "top, left",
                          },
                          attrs: { "x-placement": "top-start" },
                        },
                        [
                          _vm._l(_vm.tagsGraphics, function (item, j) {
                            return [
                              item.tag == "submenu"
                                ? _c("li", { key: j }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeChart(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\n                      " +
                                            _vm._s(item.value) +
                                            "\n\n                    "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._m(6),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ibox-content" },
                    [
                      _vm.ShowSubmenu == "informacion_EPS"
                        ? _c("Bar", {
                            attrs: {
                              height: 250,
                              declaration: _vm.informacionEPS,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.ShowSubmenu == "coronavirus"
                        ? _c("Bar", {
                            attrs: {
                              height: 250,
                              declaration: _vm.coronavirus,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.ShowSubmenu == "tramites"
                        ? _c("Bar", {
                            attrs: { height: 250, declaration: _vm.tramites },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.ShowSubmenu == "planes_complementarios"
                        ? _c("Bar", {
                            attrs: {
                              height: 250,
                              declaration: _vm.planesComplementarios,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]
        : [
            _c("Spinner", {
              attrs: {
                width: _vm.spinnerData.width,
                height: _vm.spinnerData.height,
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-form-label mx-2" }, [
      _c("b", [_vm._v("\n          Seleccione Rango:\n        ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-none d-lg-block mx-2" }, [
      _c("div", [_vm._v("-")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [_vm._v("\n              Chatbot\n            ")]),
      _vm._v(" "),
      _c("div", { staticClass: "ibox-tools" }, [
        _c("a", { staticClass: "collapse-link" }, [
          _c("i", { staticClass: "fa fa-chevron-up" }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "dropdown-toggle",
        attrs: {
          "data-toggle": "dropdown",
          href: "#",
          "aria-expanded": "true",
        },
      },
      [_c("i", { staticClass: "far fa-chart-bar" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "collapse-link" }, [
      _c("i", { staticClass: "fa fa-chevron-up" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "dropdown-toggle",
        attrs: {
          "data-toggle": "dropdown",
          href: "#",
          "aria-expanded": "true",
        },
      },
      [_c("i", { staticClass: "far fa-chart-bar" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "collapse-link" }, [
      _c("i", { staticClass: "fa fa-chevron-up" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }